module.exports = __webpack_public_path__ + "img/checked-colored-icon.54127db4.svg";